// Dr.Dog BOGO — auto-set quantity to 2 for products tagged 'bogo-active'.
// Activated via data-bogo="true" on the product form.
// Pairs with the automatic BxGy discount that takes 100% off the 2nd unit in cart.
(function () {
  const BOGO_QTY = 2;

  function isBogoForm(form) {
    return form && form.dataset && form.dataset.bogo === 'true';
  }

  function forceBogoQty(form) {
    if (!isBogoForm(form)) return;
    let qty = form.querySelector('input[name="quantity"]');
    if (!qty) {
      qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      form.appendChild(qty);
    }
    qty.value = BOGO_QTY;
  }

  // Catch native form submits (covers most themes including Dawn).
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target.closest(
        'form[action*="/cart/add"], form[id^="product-form"]'
      );
      if (form) forceBogoQty(form);
    },
    true
  );

  // Catch AJAX ATC clicks (covers cart drawers, sticky ATC bars, etc.).
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(
        'button[name="add"], [type="submit"][name="add"], [data-add-to-cart]'
      );
      if (!btn) return;
      const form = btn.closest('form');
      if (form) forceBogoQty(form);
    },
    true
  );
})();
